import * as classnames from 'classnames/bind'
import * as React from 'react'
import { FC } from 'react'
import styles from './bar_chart.module.scss'

type Data = {
  label: string
  value: string
}

const cx = classnames.bind(styles)
const Bar: FC<{
  data: Data
}> = ({ data }) => {
  return (
    <div className={cx(styles.bar)}>
      <span className={styles.barLabel}>{data.label}</span>
      <svg className={styles.barSvg}>
        <g className={styles.gElement}>
          <rect className={styles.defaultRect} x="0" y="0" width="100%" height="10" />
          <rect className={styles.rect} x="0" y="0" width={`${data.value}%`} height="10" />
        </g>
      </svg>
      <span className={styles.barValue}>{data.value}</span>
    </div>
  )
}

const BarChart: FC<{
  className?: string
  data: Data[]
}> = ({ className, data }) => (
  <div className={cx(className, styles.barChart)}>
    {data.map(d => (
      <Bar key={d.label} data={d} />
    ))}
  </div>
)

export default BarChart
